import { statusFormatterWithMap, textFormatter } from "components/Common/formatter";
import { STATUS_COLOR_MAP } from "pages/price-management/ConsumptionBands/variables";
import NGIDropdownButton from "components/Common/buttons/NGIDropdownButton";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import arrow from "assets/images/svg/arrow-white.svg";
import editCalendar from "assets/images/svg/Edit Calendar.svg";
import editPencil from "assets/images/svg/edit-pencil.svg";
import addCustomers from "assets/images/svg/add-customers.svg";
import removeCustomers from "assets/images/svg/remove-customers.svg";
import downloadCustomers from "assets/images/svg/DownloadFromCloudBlack.svg";

export const customerPriceGroupsListColumns = (styles, editItem, addRemoveCustomers, download) => [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Date Active",
    dataIndex: "activationDate",
    render: cellContent => textFormatter(cellContent),
  },
  {
    title: "Date Deactivated",
    dataIndex: "deactivationDate",
    render: cellContent => textFormatter(cellContent),
  },
  {
    title: "Owner",
    dataIndex: "owner",
    render: textFormatter,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: value => statusFormatterWithMap(value, STATUS_COLOR_MAP),
  },
  {
    title: "Customer Qty",
    dataIndex: "customersQuantity",
  },

  {
    title: "",
    width: "4%",
    key: "action",
    render: (_, row) => (
      <NGIDropdownButton
        position="left"
        toggleEl={<ButtonGroup icon={arrow} />}
        menuItems={[
          ...(row.status === "Active"
            ? [
                {
                  label: "Edit 'Active to' Date",
                  icon: editCalendar,
                  callback: () => editItem(row),
                },
                {
                  label: "Add Customers",
                  icon: addCustomers,
                  callback: () => addRemoveCustomers(row, "add"),
                },
                {
                  label: "Remove Customers",
                  icon: removeCustomers,
                  callback: () => addRemoveCustomers(row, "remove"),
                },
                row.csvFilename && {
                  label: "Download Customers",
                  icon: downloadCustomers,
                  callback: () => download(row),
                },
              ]
            : []),
          ...(row.status === "Draft"
            ? [
                {
                  label: "Edit Customer Group",
                  icon: editPencil,
                  callback: () => editItem(row),
                },
              ]
            : []),
        ]}
      />
    ),
  },
];
